import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export interface QrCodeIconProps extends SvgIconProps {}

export const QrCodeIcon = ({ style, ...iconProps }: QrCodeIconProps) => {
  return (
    <SvgIcon
      style={{ fontSize: '1em', ...style }}
      {...iconProps}
      viewBox="0 0 25 24"
    >
      <mask
        id="mask0_555_624"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_555_624)">
        <path
          d="M3.5 7.0385V3H7.5385V4H4.5V7.0385H3.5ZM3.5 21V16.9615H4.5V20H7.5385V21H3.5ZM17.4615 21V20H20.5V16.9615H21.5V21H17.4615ZM20.5 7.0385V4H17.4615V3H21.5V7.0385H20.5ZM17.4423 16.9423H18.6538V18.1538H17.4423V16.9423ZM17.4423 14.5192H18.6538V15.7308H17.4423V14.5192ZM16.2308 15.7308H17.4423V16.9423H16.2308V15.7308ZM15.0193 16.9423H16.2308V18.1538H15.0193V16.9423ZM13.8077 15.7308H15.0193V16.9423H13.8077V15.7308ZM16.2308 13.3077H17.4423V14.5192H16.2308V13.3077ZM15.0193 14.5192H16.2308V15.7308H15.0193V14.5192ZM13.8077 13.3077H15.0193V14.5192H13.8077V13.3077ZM18.6538 5.84625V10.6923H13.8077V5.84625H18.6538ZM11.1923 13.3077V18.1538H6.34625V13.3077H11.1923ZM11.1923 5.84625V10.6923H6.34625V5.84625H11.1923ZM10.3078 17.2693V14.1923H7.23075V17.2693H10.3078ZM10.3078 9.80775V6.73075H7.23075V9.80775H10.3078ZM17.7693 9.80775V6.73075H14.6923V9.80775H17.7693Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};

export default QrCodeIcon;
